function Shimmer() {
    return <div className="shimmer">
        <div className="shine lines"></div>
        <div className="shine lines"></div>
        <div style={{ width: "80%" }} className="lines shine"></div>
        <div style={{ width: "40%" }} className="lines shine"></div>
    </div>
}

export default Shimmer;